import React from "react";
import PropTypes from "prop-types";

import { useTrans } from "../../hooks";
import { Icon } from "../../shared-components";
import PublishModal, { PublishModalProps } from "./PublishModal";
import publishPartModal from "../../../helpers/publishing/client.publish-part-modal";

export const PublishButtonProps = {
  ...PublishModalProps,
  storyModel: PropTypes.object,
  isPreview: PropTypes.bool
};

const PublishButton = props => {
  const { trans } = useTrans();

  const handlePublish = () => {
    publishPartModal(props.storyModel, props.partModel, !!props.isPreview);
  };

  return !props.partModel ? null : (
    <>
      {props.partModel?.attributes?.scheduledPublishDatetime ? (
        <button className="btn publish-btn" onClick={handlePublish}>
          <Icon
            name="calendar"
            size="20"
            color="ds-neutral-00-solid"
            className="calendar-icon"
          />
          {trans("Change schedule")}
        </button>
      ) : (
        <button className="btn publish-btn" onClick={handlePublish}>
          {trans("Publish")}
        </button>
      )}
      <PublishModal {...props} />
    </>
  );
};

PublishButton.propTypes = PublishButtonProps;

export default PublishButton;
